import React from 'react'
import { MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TableBody from "@material-ui/core/TableBody";
import MuiTableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
const TableCell = withStyles({
    root: {
        border: "none"
    }
})(MuiTableCell);
const useStyles = makeStyles(theme => ({
    root: { height: '1vh' },
    rowGrid: { height: '4vh' },
    rowTitleItemStyle: { fontWeight: 600 },
    rowGridItemStyle: { border: '1px solid ' + theme.palette.grey.dark, background: theme.palette.grey.lighter, height: '4vh', width: '3%', paddingRight: 4 },
    cellGridStyle: { height: '8vh', width: '97%' },
    emptyGridStyle: { border: '1px solid ' + theme.palette.grey.dark, width: '100%', height: '4vh' },
    cellTextStyle: { fontSize: '10px' },
}));

export default function MasterScheduleForTeacher(props) {
    const i18n = props.i18n
    const days = [{ code: 'mo', "name": i18n.days.MONDAY, index: 1 },
    { code: 'tu', "name": i18n.days.TUESDAY, index: 2 },
    { code: 'we', "name": i18n.days.WEDNESDAY, index: 3 },
    { code: 'th', "name": i18n.days.THURSDAY, index: 4 },
    { code: 'fr', "name": i18n.days.FRIDAY, index: 5 },
    { code: 'sa', "name": i18n.days.SATURDAY, index: 6 },
        { code: 'su', "name": i18n.days.SUNDAY, index: 0 }
]
    const getDay = (day1) => {
        let day = days.find((d) => d.index == day1.dayNumber)
        return day.name

    }
    let header = props.header
    let timeTableForTeacher = props.timeTableForTeacher;
    const classes = useStyles();

    function getTableBody() {
        let rowArray = []
        timeTableForTeacher.map(function (teacher, index2) {
            let cellArray = []
            let cell = <TableCell className={classes.rowGridItemStyle} style={{ position: 'sticky', left: 0, zIndex: 98 }} width="100px" align='right' colspan={1}>
                <MuiTypography variant={theme.typographyStyles.BODY2} className={props.setTitleStyleBasedOnLicense(props.noOfTimeTableForTeacherToShowIndex, index2)}>
                    {teacher.id != undefined && props.showText((teacher.id).toUpperCase(), props.timeTableType, index2)}

                </MuiTypography>
            </TableCell>
            cellArray.push(cell)
            header.map(function (day1, index3) {
                if (day1.periods.length > 0) {
                    cellArray = renderTimeTable(teacher, day1, cellArray, index2)
                }
            })
            let row = <TableRow>{cellArray}</TableRow>
            rowArray.push(row);
        })
        return rowArray
    }
    function renderTimeTable(teacher, day1, cellArray, index2) {
        let returnArray = [];
        let teacherDay = teacher.days.find((day) => day.name == getDay(day1));
        if (teacherDay != undefined) {
            day1.periods.map(function (period, index1) {
                let periodObj = teacherDay.classes.find((p) => p.period == period.periodName);
                if (periodObj != undefined) {

                    if (periodObj.typeOfPeriod != 'slot') {
                        let p = {};
                        p.name = period.periodName
                        p.subject = periodObj.subject;
                        p.className = periodObj.className;
                        p.level = periodObj.level
                        p.color = periodObj.color

                        returnArray[index1] = p
                    }
                    else {
                        returnArray[index1] = periodObj
                    }
                }
                else {
                    returnArray[index1] = { typeOfPeriod: period.typeOfPeriod }
                }
            })
            returnArray.map(function (obj,indexObj) {
let lastPeriod=(returnArray.length-1==indexObj)

                if (obj.typeOfPeriod != 'slot') {
                    let cell = <TableCell style={props.getCellStyle(obj.typeOfPeriod, day1, 'cell', (obj.color != undefined ? obj.color : 'white'), (props.noOfTimeTableForTeacherToShowIndex < index2),lastPeriod)}>
                        {obj.subject != undefined ?
                            <span>
                                <MuiTypography className={props.setCellStyleBasedOnLicense(props.noOfTimeTableForTeacherToShowIndex, index2)}>
                                    {props.showText((obj.subject.code).toUpperCase(), props.timeTableType, index2)} - </MuiTypography>

                                <MuiTypography className={props.setCellStyleBasedOnLicense(props.noOfTimeTableForTeacherToShowIndex, index2)}>
                                    {props.showText((obj.className).toUpperCase(), props.timeTableType, index2)}</MuiTypography>
                            </span> :
                            <MuiTypography style={{ fontSize: '10px', wordBreak: 'break-all' }}>
                                {obj.typeOfPeriod != 'lunch' && obj.typeOfPeriod != 'break' && ''}</MuiTypography>}
                    </TableCell>
                    cellArray.push(cell)
                }
                else {
                    let cell = <TableCell padding='none' style={props.getCellStyle(obj.typeOfPeriod, day1, 'cell', (obj.color != undefined ? obj.color : 'white'),lastPeriod)}>

                        <MuiTypography style={{
                            height: '100%',
                            borderRight: (obj.rightSize != '0%') ? '1px solid ' + theme.palette.grey.main : '',
                            borderLeft: (obj.leftSize != '0%') ? '1px solid ' + theme.palette.grey.main : '',

                            backgroundImage:
                                "linear-gradient(120deg, #ffffff 31.25%, #b3b3b3 31.25%, #b3b3b3 50%, #ffffff 50%, #ffffff 81.25%, #b3b3b3 81.25%, #b3b3b3 100%)",
                            backgroundSize: "9.24px 16.00px",
                            fontSize: '10px',
                            right: obj.rightSize,
                            position: 'relative',
                            left: obj.leftSize,
                            width: obj.slotSize
                        }}>
                        </MuiTypography>

                    </TableCell>
                    cellArray.push(cell)
                }
            })
        }
        return cellArray
    }
    return (
        <TableBody>
            {getTableBody()}
        </TableBody>

    )

}
